































































import { Component, Vue } from "vue-property-decorator";
import { BModal } from "bootstrap-vue";
import { changePassword } from "@/api/user-api";

@Component({})
export default class ChangePassword extends Vue {
  currentPassword = "";
  password = "";
  passwordConfirmation = "";

  errors: string[] = [];

  reset() {
    this.currentPassword = "";
    this.password = "";
    this.passwordConfirmation = "";
    this.errors = [];
  }

  checkValidity() {
    const p = this.$refs.password as HTMLInputElement;
    if (this.password === this.passwordConfirmation) {
      p.setCustomValidity("");
    } else {
      p.setCustomValidity("入力されたパスワードが一致しません");
    }
  }

  ok() {
    this.checkValidity();
    const btn = this.$refs.btnSubmit as HTMLButtonElement;
    btn.click();
  }

  async submit(e: Event) {
    const data = new FormData(e.target as HTMLFormElement);
    try {
      await changePassword(data);
      this.$nextTick(() => {
        (this.$refs.modal as BModal).hide();
      });
    } catch (errors) {
      this.errors = errors;
    }
  }
}
